import logo from 'assets/images/logo.svg';

const appConfig = {
  appName: 'Antoree Teacher',
  appLogo: logo,
  // Firebase
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  fcmSenderId: process.env.REACT_APP_FCM_SENDER_ID,
  fcmVapidId: process.env.REACT_APP_FCM_VAPID_KEY,
  // url image
};

export default appConfig;
